/* eslint-disable
    @typescript-eslint/no-this-alias,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import _ from 'underscore';

import { Analytics } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { isOverLimit } from 'app/scripts/lib/limits';
import { View } from 'app/scripts/views/internal/View';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { PopoverAddListTemplate } from 'app/scripts/views/templates/PopoverAddListTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

interface AddListPopoverView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  closestListIdx: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  didAddList: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  lists: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listsLength: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setTimeout: any;
}

class AddListPopoverView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'add list';

    this.prototype.events = {
      // @ts-expect-error TS(2322): Type '{ 'change .js-select-list-pos': string; 'cli... Remove this comment to see the full error message
      'change .js-select-list-pos': 'renderValue',
      'click .js-add-list': 'addList',
      'submit form': 'addList',
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialize({ didAddList }: any) {
    this.didAddList = didAddList;
    return super.initialize(...arguments);
  }

  getLists() {
    this.lists = this.model.listList;
    return (this.listsLength = this.lists.length + 1);
  }

  render() {
    this.$el.html(
      PopoverAddListTemplate({
        tooManyTotalLists: isOverLimit(
          'lists',
          'totalPerBoard',
          this.model.get('limits'),
        ),
        tooManyOpenLists: isOverLimit(
          'lists',
          'openPerBoard',
          this.model.get('limits'),
        ),
      }),
    );

    // We need to use setTimeout so that PopOver.calcPos() will finish and we
    // can reliably get this element's left offset in @getClosestListPos().
    this.setTimeout(() => {
      this.getClosestListPos();
      this.getLists();
      return this.updateListList();
    }, 10);

    return this;
  }

  getClosestListPos() {
    // find closest list
    const elLists = $('.js-list');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const listxdiffs: any = [];
    this.closestListIdx = 0;

    elLists.each((i) => {
      const diff = parseInt(
        // @ts-expect-error TS(2345): Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
        Math.abs(
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          $(elLists[i]).offset().left +
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            $(elLists[i]).width() / 2 -
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            this.$el.offset().left,
        ),
        10,
      );
      return listxdiffs.push(diff);
    });

    this.closestListIdx = _.indexOf(listxdiffs, _.min(listxdiffs));

    // eslint-disable-next-line @trello/enforce-variable-case
    const $closestList = $(elLists[this.closestListIdx]);
    if (
      $closestList.length > 0 &&
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      this.$el.offset().left >
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        $closestList.offset().left + $closestList.width() / 2 &&
      this.closestListIdx < elLists.length
    ) {
      return (this.closestListIdx += 1);
    }
  }

  updateListList() {
    const view = this;

    // eslint-disable-next-line @trello/enforce-variable-case
    const $el = $(view.el);
    // eslint-disable-next-line @trello/enforce-variable-case
    const $selectList = $el.find('.js-select-list-pos');

    for (
      let i = 0, end = this.listsLength, asc = 0 <= end;
      asc ? i < end : i > end;
      asc ? i++ : i--
    ) {
      $('<option>')
        .val(i)
        .text(i + 1)
        .appendTo($selectList);
    }

    // eslint-disable-next-line @trello/enforce-variable-case
    let $option = $selectList.find('option:last');

    $option = $selectList.find(`option:eq(${this.closestListIdx})`);

    $option.attr('selected', 'selected');

    return this.renderValue();
  }

  renderValue() {
    // @ts-expect-error TS(2345): Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
    const num = parseInt($('.js-select-list-pos', this.$el).val(), 10) + 1;
    $('.js-pos-value').text(num.toString());
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addList(e: any) {
    let changedPos;
    stopPropagationAndPreventDefault(e);
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    const listName = $('.js-list-name', this.$el).val().trim();
    if (listName === '') {
      $('.js-list-name', this.$el).focus().select();
      return;
    }

    const traceId = Analytics.startTask({
      taskName: 'create-list',
      source: 'addListInlineDialog',
    });

    // eslint-disable-next-line @trello/enforce-variable-case
    const $selectListPos = $('.js-select-list-pos', this.$el);

    const listPosSelected = parseInt(
      // @ts-expect-error TS(2345): Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
      $selectListPos.find('option:selected').val(),
      10,
    );

    if (listPosSelected === this.listsLength - 1) {
      changedPos = false;
    } else {
      changedPos = true;
    }

    PopOver.hide();

    this.createList(
      {
        name: listName,
        pos: this.model.calcPos(listPosSelected),
        closed: false,
      },
      changedPos,
      traceId,
    ).catch(() => {
      return Alerts.flash('could not connect', 'error', 'addListAlert');
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createList(createListDetails: any, changedPos: any, traceId: string) {
    return new Promise((resolve, reject) => {
      const createdList = this.model.listList.createWithTracing(
        createListDetails,
        {
          traceId,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          success: (model: any) => {
            Analytics.sendTrackEvent({
              action: 'created',
              actionSubject: 'list',
              source: 'addListInlineDialog',
              containers: {
                board: {
                  id: this.model.id,
                },
                list: {
                  id: model.id,
                },
              },
              attributes: {
                changedPosition: changedPos,
              },
            });
            Analytics.taskSucceeded({
              taskName: 'create-list',
              source: 'addListInlineDialog',
              traceId,
            });
            return this.didAddList(model);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          error: (_model: any, error: any) => {
            this.model.listList.remove(createdList);
            Analytics.taskFailed({
              taskName: 'create-list',
              source: 'addListInlineDialog',
              traceId,
              error,
            });
            return reject();
          },
        },
      );
    });
  }
}

AddListPopoverView.initClass();
export { AddListPopoverView };
